var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.region),expression:"region"}],staticClass:"relative flex flex-col min-h-screen",class:{
        'blue-glow': !_vm.$route.meta.hideNavigationGlow
    },attrs:{"id":"app"}},[(!_vm.$route.meta.hideNavigation)?_c('navigation'):_vm._e(),_c('router-view',{staticClass:"flex-grow"}),(!_vm.$route.meta.hideFooter)?_c('foot'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }